
import React from "react";
import { useParams } from "react-router-dom";
import { EmptyState, ParentPageHeader, PortalLoading, useParentPortal } from "./parentPortalUtils";

function ParentChildTimetablePage() {
  const { studentId } = useParams();
  const { data, loading, reload } = useParentPortal(`parent-portal/children/${studentId}/timetable/`);
  if (loading && !data) return <PortalLoading />;

  const slots = data?.slots || [];
  const grouped = slots.reduce((acc, slot) => {
    acc[slot.day] = acc[slot.day] || [];
    acc[slot.day].push(slot);
    return acc;
  }, {});

  return (
    <div className="container-fluid py-4">
      <ParentPageHeader title="Child Timetable" subtitle={data?.student?.full_name || "Weekly class timetable"} icon="bi-calendar2-week" actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>} />
      {slots.length === 0 ? <div className="card border-0 shadow-sm"><EmptyState title="No timetable slots" /></div> : Object.entries(grouped).map(([day, rows]) => (
        <div className="card border-0 shadow-sm mb-3" key={day}>
          <div className="card-header bg-white fw-bold">{day}</div>
          <div className="table-responsive"><table className="table align-middle mb-0"><thead className="table-light"><tr><th>Period</th><th>Time</th><th>Subject</th><th>Teacher</th><th>Room</th></tr></thead><tbody>{rows.map(slot => <tr key={slot.id}><td>{slot.period}</td><td>{slot.period_time}</td><td>{slot.subject}</td><td>{slot.teacher || "-"}</td><td>{slot.room || "-"}</td></tr>)}</tbody></table></div>
        </div>
      ))}
    </div>
  );
}

export default ParentChildTimetablePage;
